"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = exports.stopTimer = exports.startNewTimer = exports.runTime = exports.getTimer = exports.fps = exports.dt = exports.calculateDeltaTime = void 0;

var utils = _interopRequireWildcard(require("./utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const calculateDeltaTime = _state => {
  const st = _state.time; //Get time in ms

  const now = Date.now(); //Get instant FPS (from last frame to this frame)

  st.fps = utils.clamp(1000 / (now - st.lastTime || 1), 5, 200); //Store this frame time

  st.lastTime = now; //Return the last frame's time (delta time) in seconds

  return 1 / st.fps;
};

exports.calculateDeltaTime = calculateDeltaTime;

const update = _state => {
  const st = _state.time; //Get the delta time

  st.dt = calculateDeltaTime(_state);
};

exports.update = update;

const startNewTimer = (_state, _id) => {
  _state.time.timers[_id] = Date.now();
};

exports.startNewTimer = startNewTimer;

const getTimer = (_state, _id) => {
  if (_state.time.timers[_id] === undefined) return undefined;
  return (Date.now() - _state.time.timers[_id]) / 1000;
};

exports.getTimer = getTimer;

const stopTimer = (_state, _id) => {
  if (_state.time.timers[_id] === undefined) return;
  delete _state.time.timers[_id];
};

exports.stopTimer = stopTimer;

const runTime = _state => {
  return (Date.now() - _state.time.gameStartTime) / 1000;
};

exports.runTime = runTime;

const dt = _state => {
  return _state.time.dt;
};

exports.dt = dt;

const fps = _state => {
  return _state.time.fps;
};

exports.fps = fps;